import { PasswordResetPage } from "./PasswordResetPage";
export default PasswordResetPage;
